import { render, staticRenderFns } from "./ApotSecond.vue?vue&type=template&id=b1fccb76&"
import script from "./ApotSecond.vue?vue&type=script&lang=js&"
export * from "./ApotSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports